import React, { useCallback, useEffect, useState } from 'react'
import { pullData } from '../Logic/index01';
import { useParams } from 'react-router-dom';
import { APIProvider, Map, Marker } from '@vis.gl/react-google-maps';

function MapUi() {

  const {k} = useParams();
  const [user, setUser] = useState();
  const [open, setOpen] = useState(false);
  const [markers, setMarkers] = useState([])



  const center = () => {
     if(navigator.geolocation)
         navigator.geolocation.getCurrentPosition(async (position) => {
             return {lat:position.coords.latitude, long:position.coords.longitude}
         },(error) => {
           console.log(error.message)          
    });
  }


  const download = () => {
    
  }



  const openUI = () => {
      if(!open){
          setOpen(true)
       }else{  
          setOpen(false);
      }
  }


  const  request = async () => {
     let waitResponse = await  pullData({obj:{key:k}})
      if(waitResponse){
         setUser(waitResponse[0]);
      }
  }
  


  const fetchLocation = useCallback(async () => {
     try {
        let waitResponse = await  pullData({obj:{key:k}})
          console.log(waitResponse);
          const response = await  waitResponse[1];              
          if(response){
            setMarkers([{lat:response[0], lng:response[1]}])
          }
         }catch(error){
           console.log(error); 
        }
  },[]);





  useEffect(() =>{
    //request();
    //fetchLocation();
    const intervalId = setInterval(fetchLocation, 5000);
    return () => clearInterval(intervalId)
  },[fetchLocation]);




  return (

      <div class="bg-blue-950 font-display text-primary h-screen w-full overflow-hidden flex">

              {open ? 
                  <aside class="block w-full flex-col  h-full border-r border-gray-800 z-20">
                    <div class="p-6 flex items-center gap-3 border-b border-gray-800/50">

                    
                        <span class="material-symbols-outlined text-lg" onClick={openUI} >close</span>
                     
                        <div class="flex items-center gap-3 p-2 rounded-lg bg-white/5 hover:bg-white/10 cursor-pointer transition-colors w-full">
                            <div class="bg-center bg-no-repeat  rounded-full size-9 ring-2 ring-white/20 flex justify-center">
                              <span class="material-symbols-outlined text-2xl text-white self-center">person</span>
                            </div>
                            <div class="flex flex-col overflow-hidden gap-2">
                              <p class="text-white text-sm font-medium truncate">{user ? user.name : ""}</p>
                              <p class="text-white text-xs truncate">{user ? user.accesscode : ""}</p>
                              <p class="text-white text-xs truncate">{user ? user.phone : ""}</p>
                            </div>
        
                     </div>
                    </div>
                </aside>
                :
                null     
               }
            
              <aside class="hidden lg:block w-72 flex-col  h-full border-r border-gray-800 z-20">
                    <div class="p-6 flex items-center gap-3 border-b border-gray-800/50">
                     
                        <div class="flex items-center gap-3 p-2 rounded-lg bg-white/5 hover:bg-white/10 cursor-pointer transition-colors w-full">
                            <div class="bg-center bg-no-repeat  rounded-full size-9 ring-2 ring-white/20 flex justify-center">
                              <span class="material-symbols-outlined text-2xl text-white self-center">person</span>
                            </div>
                            <div class="flex flex-col overflow-hidden gap-2">
                              <p class="text-white text-sm font-medium truncate">{user ? user.name : ""}</p>
                              <p class="text-white text-xs truncate">{user ? user.accesscode : ""}</p>
                              <p class="text-white text-xs truncate">{user ? user.phone : ""}</p>
                            </div>
                     
                     </div>
                    </div>
                </aside>
                <main class="flex-1 flex flex-col h-full relative overflow-hidden bg-white">
                  <header class="h-16 border-b border-gray-200 bg-white/90 backdrop-blur-sm z-10 flex items-center justify-between px-6 absolute top-0 left-0 right-0 shadow-sm">
                    <div class="flex items-center w-full h-full">
                     <div class="flex text-sm w-full justify-between">
                       <div onClick={download} class="text-primary font-bold bg-gray-100  rounded-full cursor-pointer p-2">Download audio</div>
                       <div class="block lg:hidden self-end; p-1" onClick={openUI}> 
                         <span class="material-symbols-outlined" >menu</span>
                       </div>
                    </div>
                    
                    </div>
                    
                 </header>

                    <div class="flex-1 relative bg-gray-200 w-full h-full mt-16">

                      <APIProvider apiKey={process.env.REACT_APP_GOOGLE_API_KEY}>
                        <Map
                          defaultCenter={center}
                          defaultZoom={20}
                            // mapId="YOUR_MAP_ID" // Optional: A Map ID is required for advanced features like Advanced Markers
                            >
                            {markers.map((marker, index) => (
                                <Marker
                                  key={index}
                                  position={{lat:marker.lat,lng:marker.lng}}
                                  />
                              ))};
                          </Map>
                        </APIProvider>
                        </div>
                </main>

    </div>
  )
}

export default MapUi
